// src/firebase-config.js
import { initializeApp, getApp, getApps } from "firebase/app";
import { getAuth, getIdTokenResult } from "firebase/auth"; //  getAuth, NOT initializeAuth
import { getAnalytics, logEvent } from "firebase/analytics";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { getFirestore, Timestamp } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

let app, auth, analytics, db, storage;

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);
// --- Add reCAPTCHA Site Key environment variable ---
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
// --- End reCAPTCHA Site Key ---

if (!recaptchaSiteKey) {
  console.warn(
    "App Check: REACT_APP_RECAPTCHA_SITE_KEY environment variable not set. App Check will not be initialized."
  );
}

if (!getApps().length) {
  // console.log(`Initializing Firebase`, typeof window);
  // Initialize Firebase
  app = initializeApp(firebaseConfig);

  // --- Initialize App Check ---
  // IMPORTANT: Only run this in the browser environment
  if (typeof window !== "undefined" && recaptchaSiteKey) {
    try {
      // Set self.FIREBASE_APPCHECK_DEBUG_TOKEN = true; in browser console for local testing
      // Copy the logged token into Firebase Console > App Check > Apps > Manage debug tokens
      // Make sure your reCAPTCHA v3 key is configured for localhost during development
      // console.log("Initializing Firebase App Check...", recaptchaSiteKey);
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(recaptchaSiteKey), // Use the key from env var
        isTokenAutoRefreshEnabled: true, // Recommended for automatic token refresh
      });
      // console.log("Firebase App Check initialized.");
    } catch (appCheckError) {
      console.error("Error initializing Firebase App Check:", appCheckError);
    }
  }

  // Initialize Firebase Authentication and get a reference to the service
  auth = getAuth(app); // Use getAuth for client-side
  auth.useDeviceLanguage();
  // console.log("Tenant ID: ", process.env.REACT_APP_DEFAULT_TENANT_ID);
  // strip REACT_APP_DEFAULT_TENANT_ID and remove \r  and \n
  const tenantId = process.env.REACT_APP_DEFAULT_TENANT_ID.replace(/['"]/g, '').replace(/\r/g, '').replace(/\n/g, '');
  auth.tenantId = tenantId;
  analytics = getAnalytics(app);
  storage = getStorage(app);
  db = getFirestore(app);
} else {
  // console.log(`App is already initialized`)
  app = getApp();
  auth = getAuth(app);
  // console.log("Tenant ID: ", process.env.REACT_APP_DEFAULT_TENANT_ID);
  // strip REACT_APP_DEFAULT_TENANT_ID   and remove \r  and \n
  const tenantId = process.env.REACT_APP_DEFAULT_TENANT_ID.replace(/['"]/g, '').replace(/\r/g, '').replace(/\n/g, '');
  auth.tenantId = tenantId;
  analytics = getAnalytics(app);
  storage = getStorage(app, process.env.REACT_APP_FIREBASE_STORAGE_BUCKET);
  db = getFirestore(app);
}

export {
  auth,
  analytics,
  db,
  Timestamp,
  storage,
  ref,
  getDownloadURL,
  logEvent,
  getIdTokenResult,
};
